import React from 'react';
import { BoxProps } from '@withjoy/joykit';
import { RotatingRingLoader } from '@shared/components/RotatingRingLoader/RotatingRingLoader';
import { PageLoaderOverlay } from './PageLoaderOverlay.internal';

type GenericPageLoaderProps = Readonly<{
  enableDelayedVisibility?: boolean;
  /** @default '#FFFFFF' */
  containerBgColor?: BoxProps['backgroundColor'];
  /** @default '100%' */
  containerHeight?: BoxProps['height'];
  /** @default '100%' */
  containerWidth?: BoxProps['width'];
  /** @default true */
  shouldAnimate?: boolean;
  onAnimateStop?: () => void;
}>;

/**
 * GenericPageLoader - A simple full-page spinner loader.
 *
 * This loader is used as an alternative to JoyLogoLoaderBase when the Joy logo
 * should not be displayed (e.g., for white-label/premium branding customers).
 * It uses the RotatingRingLoader with neutral colors.
 */
export const GenericPageLoader: React.FC<GenericPageLoaderProps> = props => {
  const { containerBgColor, containerHeight, containerWidth, enableDelayedVisibility, shouldAnimate, onAnimateStop } = props;

  return (
    <PageLoaderOverlay
      containerBgColor={containerBgColor}
      containerHeight={containerHeight}
      containerWidth={containerWidth}
      enableDelayedVisibility={enableDelayedVisibility}
      shouldAnimate={shouldAnimate}
      onAnimateStop={onAnimateStop}
      leaveTrail={500}
    >
      <RotatingRingLoader
        width="40px"
        height="40px"
        borderWidth="3px"
        borderColor="#e0e0e0"
        thumbColor="#666666"
      />
    </PageLoaderOverlay>
  );
};

GenericPageLoader.displayName = 'GenericPageLoader';
